// extracted by mini-css-extract-plugin
export default {"anchor":"DropDownMenu_anchor__geLWW","container":"DropDownMenu_container__NTRb8","item":"DropDownMenu_item__6Rd67","open":"DropDownMenu_open__VLi37"};